import { render, staticRenderFns } from "./pageNavigation.vue?vue&type=template&id=4cfda963&scoped=true&"
import script from "./pageNavigation.vue?vue&type=script&lang=js&"
export * from "./pageNavigation.vue?vue&type=script&lang=js&"
import style0 from "./pageNavigation.vue?vue&type=style&index=0&id=4cfda963&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfda963",
  null
  
)

export default component.exports